// import { Checkbox, Input } from "antd";
// import "antd/dist/antd.css";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addError, getCallId } from "../../Redux/UserSlice";
import {
  backendApi,
  callPlayBot,
  FinishApi,
  ThankYouApi,
  LiveCallApi
} from "../../services/service";
import LoaderComp from "../../LoaderComp";
import "./Disagreement.css";

const PersonalDisagreement = ({
  setPage,
  languageContent,
  additionalContent,
  userData
}) => {
  const dispatch = useDispatch();
  const call_id = useSelector(getCallId);
  const [error, setError] = useState("");
  const [disagreeKey, setDisagreeKey] = useState([]);
  const [liveCallResponse, setLiveCallResponse] = useState(false)


  let nudge30SecondTimer = useRef(null)
  let nudge60SecondTimer = useRef(null)

  const template_personal_disagree = async () => {
    await callPlayBot(call_id, "personal_disagree")
      .then((res) => {
        if (res.data === 200) {
          console.log("okay play api");
        }
      })
      .catch((e) => console.log(e.message));
  };
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
      await LiveCallApi(call_id)
      .then((res) => {
        console.log(res.data);
        if (res.data === false) {
          if(userData.flow_type && userData.flow_type.toLowerCase() === "hdfc"){
            setPage('callDisconnected')
            
          }
        }
        setLiveCallResponse(true)
      })
      .catch((e) => {
        setPage("sorryPage");
      });
  };

  const template_nudge = () => {
    callPlayBot(call_id, "no_input_nudge")
      .then((res) => console.log(res.data))
      .catch((e) => console.log(e.message));
  }

  const clearNudgeTimers = () => {
    clearTimeout(nudge30SecondTimer)
    clearTimeout(nudge60SecondTimer)
  }

  useEffect(() => {
    nudge30SecondTimer = setTimeout(() => template_nudge(), 30000);
    nudge60SecondTimer = setTimeout(() => template_nudge(), 60000);

    submitApi("personal_disagree_page", "open");
    template_personal_disagree();
    return () => {
      clearNudgeTimers()
    }
  }, []);
  function onChange(checkedValues) {
    console.log("checked = ", checkedValues);
    setDisagreeKey(checkedValues);
  }
  // const { TextArea } = Input;
  const [inputval, setInputVal] = useState("");
  const handleInput = (e) => {
    clearNudgeTimers()
    setInputVal(e.target.value);
  };
  const handleBack = async () => {
    clearNudgeTimers()
    await backendApi(call_id, "disagree_cancel", "click")
      .then((res) => {
        if (res.data) {
          setPage("personalDetails");
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
  };
  const onSubmit = async () => {
    clearNudgeTimers()
    if (disagreeKey.length > 0 && inputval.length > 0) {
      await submitApi("disagree_submit", "click");
      await submitApi("personal_disagree_reasons", disagreeKey.toString());
      await submitApi("personal_disagree_details", inputval);
      await ThankYouApi(call_id)
        .then((res) => console.log(res.data))
        .catch((e) => {
          dispatch(addError(e.message));
          setPage("sorryPage");
        });
      await FinishApi(call_id)
        .then((res) => setPage("thankYou"))
        .catch((e) => {
          dispatch(addError(e.message));
          setPage("sorryPage");
        });
    } else {
      setError(languageContent.disagree_page.reason);
    }
  };
  // const [disagreeKey, setDisagreeKey] = React.useState([]);
  const [optionsState, setOptionsState] = React.useState(
    additionalContent.personal_disagreeList
  );
  const handleItemChange = (e, id) => {
    clearNudgeTimers()
    const { checked, name } = e.target;
    console.log(optionsState);
    console.log(checked, name);
    let u = optionsState;
    u.forEach((item, index) => {
      if (index === id) {
        item.checked = !item.checked;
      }
    });
    let dl = [];
    u.forEach((item) => {
      if (item.checked === true) {
        dl.push(item.value);
      }
    });
    // u.forEach((item)=>{
    //   if(item.label===name){
    //     item.checked=!item.checked
    //   }})
    console.log(u);
    setOptionsState([...u]);
    setDisagreeKey([...dl]);
  };
  return (
    liveCallResponse ? 
    <>
      <div className="heading">
        <p>{languageContent.disagree_page.personal_title}</p>
      </div>
      <hr></hr>
      <p>{languageContent.disagree_page.disagree_title}</p>
      {optionsState.map((item, index) => {
        // console.log(item);
        return (
          <>
            <div style={{ display: "flex" }} key={index}>
              <input
                style={{ marginRight: "0.5rem" }}
                type="checkbox"
                id={`check-${item.name}`}
                name={item.label}
                checked={item.checked}
                onChange={(e) => handleItemChange(e, index)}
                key={index}
              />
              <label htmlFor={`check-${item.value}`}>{item.label}</label>
            </div>
          </>
        );
      })}
      {/* <Checkbox.Group
        style={{ textAlign: "left", fontSize: "1rem", color: "red" }}
        options={additionalContent.personal_disagreeList}
        onChange={onChange}
      /> */}
      <p>{languageContent.disagree_page.remarks}</p>
      <textarea
        rows={3}
        value={inputval}
        onChange={handleInput}
        style={{
          border: "1.5px solid #c7222a",
          boxShadow: "none",
          borderRadius: "5px",
          width: "100%",
        }}
      />
      {/* <TextArea
        value={inputval}
        onChange={handleInput}
        style={{
          border: "1.5px solid #c7222a",
          boxShadow: "none",
          borderRadius: "5px",
        }}
      /> */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginTop: "16px",
        }}
      >
        <button
          className="backButton"
          id="personal_details_disagree_back"
          onClick={handleBack}
        >
          {languageContent.buttons.back}
        </button>
        <button
          className="btn-next-disagree-thankyou myButton"
          onClick={onSubmit}
        >
          {languageContent.buttons.next}
        </button>
      </div>
      {error && (
        <p style={{ color: "red", fontWeight: "bold", marginTop: "0.35rem" }}>
          {error}
        </p>
      )}
    </>
    : <LoaderComp />
  );
};

export default PersonalDisagreement;
